/**
 * US States and timezone data
 */

export const US_STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
  "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "District of Columbia"
];

// State to timezone mapping
export const STATE_TIMEZONES: { [key: string]: string } = {
  "Alabama": "CST (UTC-6)",
  "Alaska": "AKST (UTC-9)",
  "Arizona": "MST (UTC-7)",
  "Arkansas": "CST (UTC-6)",
  "California": "PST (UTC-8)",
  "Colorado": "MST (UTC-7)",
  "Connecticut": "EST (UTC-5)",
  "Delaware": "EST (UTC-5)",
  "Florida": "EST (UTC-5)",
  "Georgia": "EST (UTC-5)",
  "Hawaii": "HST (UTC-10)",
  "Idaho": "MST (UTC-7)",
  "Illinois": "CST (UTC-6)",
  "Indiana": "EST (UTC-5)",
  "Iowa": "CST (UTC-6)",
  "Kansas": "CST (UTC-6)",
  "Kentucky": "EST (UTC-5)",
  "Louisiana": "CST (UTC-6)",
  "Maine": "EST (UTC-5)",
  "Maryland": "EST (UTC-5)",
  "Massachusetts": "EST (UTC-5)",
  "Michigan": "EST (UTC-5)",
  "Minnesota": "CST (UTC-6)",
  "Mississippi": "CST (UTC-6)",
  "Missouri": "CST (UTC-6)",
  "Montana": "MST (UTC-7)",
  "Nebraska": "CST (UTC-6)",
  "Nevada": "PST (UTC-8)",
  "New Hampshire": "EST (UTC-5)",
  "New Jersey": "EST (UTC-5)",
  "New Mexico": "MST (UTC-7)",
  "New York": "EST (UTC-5)",
  "North Carolina": "EST (UTC-5)",
  "North Dakota": "CST (UTC-6)",
  "Ohio": "EST (UTC-5)",
  "Oklahoma": "CST (UTC-6)",
  "Oregon": "PST (UTC-8)",
  "Pennsylvania": "EST (UTC-5)",
  "Rhode Island": "EST (UTC-5)",
  "South Carolina": "EST (UTC-5)",
  "South Dakota": "CST (UTC-6)",
  "Tennessee": "CST (UTC-6)",
  "Texas": "CST (UTC-6)",
  "Utah": "MST (UTC-7)",
  "Vermont": "EST (UTC-5)",
  "Virginia": "EST (UTC-5)",
  "Washington": "PST (UTC-8)",
  "West Virginia": "EST (UTC-5)",
  "Wisconsin": "CST (UTC-6)",
  "Wyoming": "MST (UTC-7)",
  "District of Columbia": "EST (UTC-5)"
};
